import styles from "./picker-option.module.css";

export default function PickerOption({
  children,
  ...props
}: { children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={styles.pickerOption} {...props}>
      {children}
    </div>
  );
}
